import Case1 from "@/assets/svg/creator-shield/case-1.svg";
import Case2 from "@/assets/svg/creator-shield/case-2.svg";
import Case3 from "@/assets/svg/creator-shield/case-3.svg";
import Case4 from "@/assets/svg/creator-shield/case-4.svg";
import Case5 from "@/assets/svg/creator-shield/case-5.svg";
import Case6 from "@/assets/svg/creator-shield/case-6.svg";

export default function CaseStudies() {
  const caseStudies = [
    {
      type: "Cleaning Content Creator",
      monthlyRevenue: "$3K+",
      claimsMade: "100+",
      image: Case1,
    },
    {
      type: "Beauty Content Creator",
      monthlyRevenue: "$4K+",
      claimsMade: "500+",
      image: Case2,
    },
    {
      type: "ASMR Content Creator",
      monthlyRevenue: "$3K+",
      claimsMade: "4,500+",
      image: Case3,
    },
    {
      type: "D.I.Y Content Creator",
      monthlyRevenue: "$2K+",
      claimsMade: "50+",
      image: Case4,
    },
    {
      type: "Beauty Content Creator",
      monthlyRevenue: "$1K+",
      claimsMade: "1,000+",
      image: Case5,
    },
    {
      type: "HairStylist Content Creator",
      monthlyRevenue: "$500+",
      claimsMade: "75+",
      image: Case6,
    },
  ];

  return (
    <div className="bg-white py-20 px-6 md:px-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto">
        <div className="text-center mb-12 space-y-4 no-animation">
          <p className="text-[#66bb6a] font-semibold text-xl uppercase tracking-wide">
            REAL RESULTS
          </p>
          <h2 className="text-5xl xl:text-6xl text-center font-semibold px-4">
            Case Studies
          </h2>
          <p className="text-lg text-black">
            See how creators across different niches are earning recurring
            revenue from their protected content.
          </p>
        </div>

        {/* Case Study Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[25px] w-full max-w-[1440px] mx-auto">
          {caseStudies.map((study, index) => (
            <div
              key={index}
              className="bg-white border border-[#ddd] rounded-[20px] overflow-clip relative h-[525px] xs:h-[485px] md:h-[530px] transition-all duration-300 ease-out hover:-translate-y-2 hover:shadow-xl cursor-pointer"
            >
              {/* Image */}
              <div className="absolute h-[262px] left-0 top-0 w-full overflow-clip">
                <img
                  src={study.image}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content Area */}
              <div className="absolute left-[31px] md:left-[36px] right-[31px] md:right-[36px] top-[262px] bottom-0 flex flex-col justify-start pt-6 md:pt-[46px]">
                {/* Title */}
                <p className="text-xl md:text-3xl font-normal text-black mb-2 md:mb-6 xs:mb-5">
                  {study.type}
                </p>

                {/* Contextual Line */}
                <p className="text-sm md:text-base text-gray-600 mb-2">
                  Through CreatorShield, they
                </p>

                {/* Main Text with Highlighted Values */}
                <p className="text-2xl md:text-4xl text-black leading-relaxed" style={{ lineHeight: "1.2" }}>
                  Generated over{" "}
                  <span className="text-[#34c759] font-semibold">
                    {study.monthlyRevenue}
                  </span>{" "}
                  month
                  revenue and with{" "}
                  <span className="text-[#34c759] font-semibold">
                    {study.claimsMade}
                  </span>{" "}
                  claims made.
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
